var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #64dd17;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fafafa;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.67,0h26.67c5.89,0,10.67,4.78,10.67,10.67v26.67c0,5.89-4.78,10.67-10.67,10.67H10.67c-5.89,0-10.67-4.78-10.67-10.67V10.67C0,4.78,4.78,0,10.67,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.74,37.24c-.16,0-.33,0-.49,0-4.82-.12-7.97-3.08-9.04-4.26-.24-.26-.23-.65.01-.91l2.22-2.5c.24-.25.62-.28.89-.07.98.77,3.26,2.74,6.26,2.9,3.48.19,5.11-.8,5.31-2.31.2-1.43-.5-2.65-4.37-3.65-6.91-1.79-8.15-5.83-7.73-9.2.45-3.55,4.12-6.37,8.38-6.33,6.09.06,9.84,2.78,11.15,3.92.29.25.3.7.02.97l-2.11,2.38c-.22.22-.56.26-.82.09-1.07-.69-3.19-2.77-6.98-2.77-2.33,0-3.75.89-3.9,2.05-.21,1.63.88,3.03,4.21,3.78,7.37,1.66,8.61,5.96,7.83,9.42-.72,3.19-4.37,6.47-10.84,6.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m29.38,14.12l1.12-5.32c.09-.41-.23-.8-.65-.8h-4.09c-.31,0-.59.22-.65.53l-1.12,5.35,5.4.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.89,33.33l-1.23,5.86c-.09.41.23.8.65.8h4.09c.31,0,.59-.22.65-.53l1.29-6.14h-5.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashapp);
export default __webpack_public_path__ + "static/media/cashapp.ded0499c63f97629e795fea0f5fa169d.svg";
export { ForwardRef as ReactComponent };